module.exports = __webpack_public_path__ + "img/file.c0766b86.svg";